import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#111827] text-white pt-16 pb-8" role="contentinfo" aria-label="Seitenfuß">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Spalte 1: Logo & Info */}
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer" aria-label="gowiTEC – Zur Startseite">
              <img
                src="https://public.readdy.ai/ai/img_res/14f1f06c-918d-4446-9087-9b10eac1e38e.png"
                alt="gowiTEC – Systemkomponenten + SPS-Technik"
                className="h-12 w-auto object-contain"
                loading="lazy"
              />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Ihr Partner für Sondermaschinenbau, SPS-Steuerung und Automatisierungstechnik – seit 1992.
            </p>
            <address className="not-italic text-gray-400 text-sm leading-relaxed">
              Gewerbeparkstr. 8<br />
              51580 Reichshof-Wehnrath<br />
              Deutschland
            </address>
          </div>

          {/* Spalte 2: Navigation */}
          <nav aria-label="Footer-Navigation">
            <h3 className="text-white font-semibold text-base mb-5">Navigation</h3>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Startseite</Link></li>
              <li><Link to="/ueber-uns" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Über uns</Link></li>
              <li><Link to="/leistungen" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Leistungen</Link></li>
              <li><Link to="/kontakt" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Kontakt</Link></li>
              <li><Link to="/referenzen" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Referenzen</Link></li>
              <li><Link to="/stellenangebote" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Stellenangebote</Link></li>
              <li><Link to="/anfrage" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Projekt anfragen</Link></li>
              <li>
                <Link
                  to="/shop"
                  className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-1.5"
                  aria-label="Shop öffnen"
                >
                  <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true">
                    <i className="ri-store-2-line text-xs"></i>
                  </span>
                  Shop
                </Link>
              </li>
            </ul>
          </nav>

          {/* Spalte 3: Kontakt & Rechtliches */}
          <div>
            <h3 className="text-white font-semibold text-base mb-5">Kontakt</h3>
            <ul className="flex flex-col gap-3 mb-8">
              <li>
                <a href="tel:+491776512122" className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2 cursor-pointer" aria-label="Telefon: +49 1776512122">
                  <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true"><i className="ri-phone-line text-[#DC2626]"></i></span>
                  +49 1776512122
                </a>
              </li>
              <li>
                <a href="mailto:anfrage@gowitec.de" className="text-gray-400 text-sm hover:text-white transition-colors flex items-center gap-2 cursor-pointer break-all" aria-label="E-Mail: anfrage@gowitec.de">
                  <span className="w-4 h-4 flex items-center justify-center" aria-hidden="true"><i className="ri-mail-line text-[#DC2626]"></i></span>
                  anfrage@gowitec.de
                </a>
              </li>
            </ul>
            <nav aria-label="Rechtliche Links">
              <h3 className="text-white font-semibold text-base mb-3">Rechtliches</h3>
              <ul className="flex flex-col gap-2">
                <li><Link to="/impressum" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Impressum</Link></li>
                <li><Link to="/datenschutz" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">Datenschutzerklärung</Link></li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Partner-Logos */}
        <div className="border-t border-gray-800 pt-10 pb-8 mb-2">
          <p className="text-gray-500 text-xs uppercase tracking-widest text-center mb-6">Zertifizierte Partnerschaften</p>
          <div className="flex flex-wrap items-center justify-center gap-8" role="list" aria-label="Zertifizierte Partner">
            <div className="flex items-center justify-center bg-white/5 hover:bg-white/10 transition-colors rounded-lg px-6 py-3 w-44 h-16" role="listitem">
              <img
                src="https://storage.readdy-site.link/project_files/0c485b57-fedb-40d8-8940-c50727e75c3c/ea5995e0-9dcf-47d1-8c59-f33463c37dba_omron-logo.png?v=730df7f83e8bf2acd7c585b214dde13e"
                alt="OMRON – Autorisierter Partner gowiTEC"
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
            <div className="flex items-center justify-center bg-white/5 hover:bg-white/10 transition-colors rounded-lg px-6 py-3 w-44 h-16" role="listitem">
              <img
                src="/images/loxo_partner.jpg"
                alt="Loxone – Autorisierter Partner"
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">© {new Date().getFullYear()} gowiTEC. Alle Rechte vorbehalten.</p>
          <p className="text-gray-600 text-xs">Automatisierung · SPS-Technik · Sondermaschinenbau</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
